import { applyMiddleware, createStore } from 'redux';
import reducer from './reducer';
import * as _ from 'lodash';
import pixelMiddleware from 'login-middleware/pixelMiddleware';
import createLogger from 'redux-logger';
import ReduxThunk from 'redux-thunk';

const logger = createLogger({
  collapsed: true,
  predicate: () => {
    if (_.get(global, 'IS_TEST')) {
      return false;
    }
    const env = window.NODE_ENV;
    return _.includes(['dev', 'sandbox'], env);
  },
});

export default function configureStore(initialState = {}) {
  return createStore(reducer, initialState, applyMiddleware(pixelMiddleware, ReduxThunk, logger));
}
